class DocumentGameResults {

    constructor() {

        this._popUpGameResultsTemplate = null;
        this._baseScreenTemplate = null;

        this._loadTemplates();

    }

    _loadTemplates() {

        this._popUpGameResultsTemplate = Handlebars.compile($("#gameResultsPopUp").html());
        this._baseScreenTemplate = Handlebars.compile($("#baseScreen").html());

    }

    // IZE-9629 (FR-010, superado por FR-023): la regla de completitud del Juego ya no se recalcula
    // en el cliente (evitaba el bug histórico de la regla "100% aciertos", que llegó a compararse
    // como >= 50%). El propio endpoint `.../register` (ya invocado por `sendCompleteDocumentGame`,
    // antes `.../complete`) evalúa la regla en el backend y devuelve el veredicto en
    // `gameResults.completion` — el frontend solo lee ese resultado y refleja el estado en la UI
    // si la completitud es nueva. No existe ni existió ningún paso de verificación previa
    // (`completion-game-check`) real en este flujo.
    _checkGameCompletion(document, gameResults) {

        const completion = gameResults.completion;

        if (!completion) {
            return;
        }

        document.completed = !!completion.completed;

        if (completion.completed && completion.completed_now) {
            documentationScreenController.documentationProgress.markCompletedLocally(
                document.id,
                0,
                completion.completion_date,
                true
            );
        }

    }

    updateGameDocument(gameResults) {

        let document = documentationScreenController.getDocument(gameResults.document_id);

        if (document) {
            document.own_game.games = gameResults.games;
            document.own_game.last_game = _.maxBy(document.own_game.games, function(game) { return game.end_date });
            if (document.own_game.last_game) {
                document.own_game.last_game.show_points = !document.own_game.num_tries || document.own_game.num_tries > 1;
            }
            document.own_game.user_rank = gameResults.user_position;

            const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

            if (isModuleApp) {
                // update module-app content
                window.reactZustandBridge.updateContentByContentId(gameResults.document_id, document);

                // update legacy document
                documentationScreenController.documentsAsResources[gameResults.document_id] = document;
            }
        }

        documentObj.own_game.games = gameResults.games;
        documentObj.own_game.last_game = _.maxBy(documentObj.own_game.games, function(game) { return game.end_date });
        // Show points can't be reasigned, so cloning the object
        documentObj.own_game.last_game = {
            ...documentObj.own_game.last_game,
            show_points: !documentObj.own_game.num_tries || documentObj.own_game.num_tries > 1
        } 
        documentObj.own_game.user_rank = gameResults.user_position;
        if (gameResults.games && gameResults.games.length > 0) {
            user.points += gameResults.games[0].total_points;
        }

        if (!documentObj.is_path_content) {
            // Si es juego y no es del path dejar de registrar tiempo al terminar el juego
            documentationScreenController.documentationProgress.stopRead(gameResults.document_id);
            this._checkGameCompletion(document, gameResults);
        }

        documentationScreenController.showLastGamePoints = true;

    }

    showResultsPopUp() {

        const context = {
            document: documentObj
        }

        popUpController.setPopUp(this._popUpGameResultsTemplate, context);
        popUpController.showPopUp("center");

    }

    showAssessmentResultsPopUp() {

        documentationScreenController.documentationPath.openAssessmentResultsPopUp(documentObj);

        const $closePopUpButton = $("div.action-button.path-assessment-confirm-button");
        $closePopUpButton.one("click.goToMainApp", this.goToMainApp.bind(this));


    }

    hideResultsPopUp() {
        popUpController.hidePopUp();
    }

    goToMainApp() {

        function _onTransitionComplete() {

            if (documentObj.path_document_id) {

                document = documentationScreenController.getDocument(documentObj.path_document_id);
                parentFolder = documentationScreenController.getParentFolder(documentObj.path_document_id, documentationScreenController.documentation);
                documentationScreenController.documentationPath.getPath(document.path_id, onGetPathSuccess);

            } else {

                document = documentationScreenController.getDocument(documentObj.id);
                parentFolder = documentationScreenController.getParentFolder(documentObj.id, documentationScreenController.documentation);

                drawDocumentDetails();

            }

        }

        function onGetPathSuccess(pathData) {

            document.pathData = pathData;
            drawDocumentDetails();

        }

        function drawDocumentDetails() {
            const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

            // Force this flow when is module app
            if (isModuleApp || baseController?.currentActiveTab?.id === new Tabs().LINKS_TAB) {
                if (isModuleApp) {
                    $('#countdownScreen.stackable').remove();
                }

                $mainContainer.html(that._baseScreenTemplate(world));

                if (world.is_lms && storage.getItem("lms_path_id")) {
                    $("#appHeader").removeClass("world_color_1_bg");
                }

                baseController.draw(world.theme);
                documentationScreenController.openDocumentation(documentationScreenController.documentation, null, null, false);
                documentationScreenController.drawDocumentDetails(null, document, null, parentFolder);

            } else {
                baseController.selectedTabAction(baseController.currentActiveTab.world_tab_id);
            }
        }

        const $mainContainer = $("#mainContainer");
        const that = this;
        let document = null;
        let parentFolder = null;

        setTimeout(_onTransitionComplete, popUpController.getAnimationSpeed());

    }

}